import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOLink } from "src/app/shared/models/oo-link";

@Component({
	selector: "app-link-qr-export",
	templateUrl: "./link-qr-export.component.html",
	styleUrls: ["./link-qr-export.component.scss"],
})
export class LinkQrExportComponent implements OnInit {
	@Input() linkList: OOLink[];
	@Output() linkListChange = new EventEmitter<OOLink[]>();

	@Input() showPrintable: boolean;
	@Output() showPrintableChange = new EventEmitter<boolean>();

	showTableId: boolean = false;

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		const baseUrl = "https://app.focuspos.com";
		this.linkList.forEach((link) => {
			link.url = `${baseUrl}/${this.venueService.subscriptionVenue.value.key}?linkKey=${link.key}`;
		});
	}

	// print() {
	// 	var printContents = document.getElementById("printableArea").innerHTML;
	// 	console.log(printContents);
	// 	var originalContents = document.body.innerHTML;

	// 	document.body.innerHTML = printContents;

	// 	window.print();

	// 	document.body.innerHTML = originalContents;
	// }

	async print() {
		this.app.loading(true);
		var data = document.getElementById("printableArea");
		const defaultShadowStyle = window.getComputedStyle(data).boxShadow;
		setShadowStyle(data, "none");
		const canvas = await html2canvas(data, {
			scale: 2,
		});

		const imgData = canvas.toDataURL("image/png");
		var imgWidth = 208;
		var pageHeight = 298;
		var imgHeight = (canvas.height * imgWidth) / canvas.width;
		var heightLeft = imgHeight;

		var doc = new jsPDF("p", "mm", "a4", true);
		var position = 0;
		doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;

		while (heightLeft >= 0) {
			position = heightLeft - imgHeight;
			doc.addPage();
			doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		}

		doc.save("link-qr.pdf");
		this.app.loading(false);

		// const binary = doc.output();
		// setShadowStyle(data, defaultShadowStyle);

		// return binary ? btoa(binary) : "";

		// A function that assigns a shadow style to an element
		function setShadowStyle(el, shadowStyle) {
			el.style.boxShadow = shadowStyle;
		}
	}
}
